import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import { Nav, NavProps } from 'yoso';
import './TabNav.scss';

export type TabNavProps = NavProps;

/**
 * @deprecated Use Tabs instead.
 */
export const TabNav = forwardRef(function TabNav(
  { className, ...props }: TabNavProps,
  ref: ForwardedRef<HTMLOListElement>
) {
  return <Nav className={classNames('tab-nav', className)} {...props} ref={ref} />;
});
